// ////////////////////////////スマホ/タブレット判別
var _ua = (function (u) {
  return {
    Tablet:
      (u.indexOf('windows') != -1 && u.indexOf('touch') != -1) ||
      u.indexOf('ipad') != -1 ||
      (u.indexOf('android') != -1 && u.indexOf('mobile') == -1) ||
      (u.indexOf('firefox') != -1 && u.indexOf('tablet') != -1) ||
      u.indexOf('kindle') != -1 ||
      u.indexOf('silk') != -1 ||
      u.indexOf('playbook') != -1,
    Mobile:
      (u.indexOf('windows') != -1 && u.indexOf('phone') != -1) ||
      u.indexOf('iphone') != -1 ||
      u.indexOf('ipod') != -1 ||
      (u.indexOf('android') != -1 && u.indexOf('mobile') != -1) ||
      (u.indexOf('firefox') != -1 && u.indexOf('mobile') != -1) ||
      u.indexOf('blackberry') != -1,
  };
})(window.navigator.userAgent.toLowerCase());
// if(_ua.Mobile){}

var osVer;
osVer = 'Android';

var ua = navigator.userAgent.toLowerCase();
var iPadFlag = false;
if (/android|ipod|ipad|iphone|macintosh/.test(ua) && 'ontouchend' in document) {
  iPadFlag = true;
  $('#wrapper').addClass('setTouch');
}
// if (navigator.userAgent.indexOf(osVer)>0){
// }

var breakNum = 768;
var tabletNum = 1024;
// ////////////////////////////////////init
// $(function () {
//   // setScroll();
//   // if ($('#wrapper').hasClass('home')) {
//   //   setWave();
//   // }
//   // ///////////
//   // if (!_ua.Mobile && !_ua.Tablet) {
//   //   $('#wrapper').addClass('desktop');
//   //   if (!$('#wrapper').hasClass('about')) {
//   //     $('html, body').prop({
//   //       scrollTop: 0,
//   //     });
//   //     if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1 && ua.indexOf('edge') === -1) {
//   //       // ここにSafari用の記述
//   //     } else {
//   //     }
//   //   }
//   // }
//   // ///////////
// });

$(window).on('load', function () {
  // heightLineGroup();
  judgeWinSize();
  setSpan();
  // setInview();
  setAcc();
  // setMegaMenu();
  startScroll();
  setMainMenu();
  setLoaded();
  if ($('#wrapper').hasClass('home')) {
    setGsap();
  }
  setWay();
  // mailTo();
  setHeader();
  setClose();
});

//終了対応
function setClose() {
  $('#wrapper').addClass('finish');
  $('.finishArea,.finishCloseBtn').on('click', function () {
    $('#wrapper').removeClass('finish');
    $('#closeSec')
      .fadeOut()
      .queue(function () {
        this.remove();
      });
  });
}

// //////////////////////////メインメニュー
function setMainMenu() {
  $('#mainMenu').on('click', function () {
    if (!$('#mainMenu').hasClass('active')) {
      openFnc();
    } else {
      closeFnc();
    }
  });
  $('#clickBlocker').on('click', function (event) {
    event.stopPropagation();
    closeFnc();
  });

  var winW = $(window).width();
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    winW = $(window).width();
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearInterval(timer);
    }
    timer = setTimeout(function () {
      if (winW > tabletNum) {
        closeFnc();
      }
    }, 200);
  });
}

function openFnc() {
  current_scrollY = $(window).scrollTop();
  $('#mainMenu').addClass('active');
  $('#wrapper').addClass('menuOpen');
  $('#outerMenu').css('top', -current_scrollY);
}

function closeFnc() {
  $('#mainMenu').removeClass('active');
  $('#outerMenu').css('top', '');
  $('#wrapper').removeClass('menuOpen');
  $('html, body').prop({
    scrollTop: current_scrollY,
  });
}

var current_scrollY = 0;

//Gsap
function setGsap() {
  /* --------------------
smooth scroll
固定ヘッダーのとき
-------------------- */
  // gsap.registerPlugin(ScrollToPlugin);
  // // ヘッダーの要素を取得（例えば.headerだった場合）
  // // const h = document.getElementsByClassName('header')[0];
  // gsap.utils.toArray('a[href^="#"]').forEach(function (a) {
  //   a.addEventListener('click', function (e) {
  //     e.preventDefault();
  //     gsap.to(window, {
  //       duration: 1,
  //       ease: 'power4.out',
  //       scrollTo: {
  //         y: e.target.getAttribute('href'),
  //         autoKill: false,
  //         // offsetY: h.offsetHeight, //ヘッダーの高さをセット
  //       },
  //     });
  //   });
  // });

  gsap.registerPlugin(ScrollTrigger);
  gsap.fromTo(
    '.gsap_01',
    {
      autoAlpha: 0, // x軸方向に500pxの位置から100pxの位置まで移動しながらフェードインさせる
    },
    {
      autoAlpha: 1,
      scrollTrigger: {
        trigger: '.gsap_01', // アニメーション開始のトリガー要素
        start: 'top center', // アニメーション開始位置
        end: 'bottom 20%',
        toggleActions: 'play none none reverse',
        // scrub: true,
        // markers: true,
        // toggleClass: { targets: '.gsap_01', className: 'is-active' },
      },
    }
  );
  /////////
  let mm = gsap.matchMedia();
  mm.add('(min-width: 769px)', () => {
    let targetEl;
    targetEl = document.querySelector('.slideSection_01');
    const listWrapperEl = document.querySelector('.slideContent_01');
    const listEl = document.querySelector('.slidesWrapper');

    gsap.to(listEl, {
      x: () => -(listEl.clientWidth - listWrapperEl.clientWidth),
      ease: 'none',
      scrollTrigger: {
        trigger: targetEl,
        start: 'top top',
        end: () => `+=${listEl.clientWidth - listWrapperEl.clientWidth}`,
        scrub: true,
        pin: true,
        anticipatePin: 1,
        invalidateOnRefresh: true,
      },
    });
  });

  /////////
  gsap.to('.gsap_02', {
    scrollTrigger: {
      trigger: '.gsap_02', // アニメーション開始のトリガー要素
      start: 'top center', // アニメーション開始位置
      end: 'bottom 20%',
      // toggleActions: 'play none none reverse',
      // scrub: true,
      // markers: true,
      toggleClass: { targets: '.gsap_02', className: 'is-activegsap' },
    },
  });
  /////////
  gsap.fromTo(
    '.gsap_03',
    {
      autoAlpha: 0, // x軸方向に500pxの位置から100pxの位置まで移動しながらフェードインさせる
    },
    {
      autoAlpha: 1,
      scrollTrigger: {
        trigger: '.gsap_03', // アニメーション開始のトリガー要素
        start: 'top center', // アニメーション開始位置
        end: 'bottom 20%',
        toggleActions: 'play none none reverse',
        // scrub: true,
        // markers: true,
        toggleClass: { targets: '.gsap_03', className: 'is-activegsap' },
      },
    }
  );
  /////////
  gsap.fromTo(
    '.gsap_04',
    {
      autoAlpha: 0, // x軸方向に500pxの位置から100pxの位置まで移動しながらフェードインさせる
    },
    {
      autoAlpha: 1,
      scrollTrigger: {
        trigger: '.gsap_04', // アニメーション開始のトリガー要素
        start: 'top center', // アニメーション開始位置
        end: 'bottom 20%',
        toggleActions: 'play none none reverse',
        // scrub: true,
        // markers: true,
        toggleClass: { targets: '.gsap_04', className: 'is-activegsap' },
      },
    }
  );
  /////////
  gsap.fromTo(
    '.gsap_05',
    {
      autoAlpha: 0, // x軸方向に500pxの位置から100pxの位置まで移動しながらフェードインさせる
    },
    {
      autoAlpha: 1,
      scrollTrigger: {
        trigger: '.gsap_05', // アニメーション開始のトリガー要素
        start: 'top center', // アニメーション開始位置
        end: 'bottom 20%',
        toggleActions: 'play none none reverse',
        // scrub: true,
        // markers: true,
        toggleClass: { targets: '.gsap_05', className: 'is-activegsap' },
      },
    }
  );
  /////////
  const listWrapperEl_03 = document.querySelector('.slideContent_03');
  const listEl_03 = document.querySelector('.slidesWrapper_03');

  gsap.to(listEl_03, {
    x: () => -(listEl_03.clientWidth - listWrapperEl_03.clientWidth),
    ease: 'none',
    scrollTrigger: {
      trigger: '.slideSection_03',
      start: 'top top',
      end: () => `+=${listEl_03.clientWidth - listWrapperEl_03.clientWidth}`,
      scrub: true,
      pin: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
    },
  });
  /////////
  gsap.to('.reservationSec', {
    scrollTrigger: {
      trigger: '.reservationSec',
      start: 'top center', // アニメーション開始位置
      end: 'bottom 20%',
      // toggleActions: 'play none none reverse',
      // scrub: true,
      // markers: true,
      toggleClass: { targets: '#wrapper', className: 'hideCnv' },
    },
  });

  ////
  // const observer = new ResizeObserver((entries) => {
  //   ScrollTrigger.refresh();
  // });
  // observer.observe(document.querySelector('.slideSection_01'));
}

// ///////ヘッダー制御
let set_position = 0;
function setHeader() {
  var timer = false;
  $(window).on('resize', function () {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $('header').removeClass('fixedHeader');
      $('header').removeClass('fixedHeaderDelay');
    }, 10);
  });

  set_position = $(this).scrollTop();

  fixedHeader();
  // console.log($('#mainVis').height())

  $(window).scroll(function () {
    fixedHeader();
  });

  function fixedHeader() {
    h = $('.kv').height() - 50;
    baseHeight = h;
    baseHeight2 = h * 2;
    if ($(this).scrollTop() < baseHeight) {
      $('#wrapper').removeClass('fixedHeader');
    } else if ($(this).scrollTop() >= baseHeight) {
      $('#wrapper').addClass('fixedHeader');
    }
    if ($(this).scrollTop() < baseHeight2) {
      $('#wrapper').removeClass('fixedHeader2');
    } else if ($(this).scrollTop() >= baseHeight2) {
      $('#wrapper').addClass('fixedHeader2');
    }
    if (set_position < $(this).scrollTop()) {
      $('#wrapper').addClass('scrollDown');
      $('#wrapper').removeClass('scrollUp');
    } else {
      $('#wrapper').addClass('scrollUp');
      $('#wrapper').removeClass('scrollDown');
    }
    set_position = $(this).scrollTop();

    // ウィンドウの高さ
    var windowHeight = window.innerHeight;
    // スクロールされた距離
    var scrollY = window.scrollY || window.pageYOffset;
    // ドキュメントの全高さ
    var documentHeight = document.documentElement.scrollHeight;

    var windowHeight = window.innerHeight;
    // スクロールされた距離
    var scrollY = window.scrollY || window.pageYOffset;
    // ドキュメントの全高さ
    var documentHeight = document.documentElement.scrollHeight;
    // #wrapper 要素を取得
    var wrapper = document.getElementById('wrapper');

    // ウィンドウの最下部に達したか判定
    if (windowHeight + scrollY >= documentHeight) {
      // 最下部に達した場合、#wrapperにクラスを追加
      wrapper.classList.add('is-scrollEnd');
    } else {
      // 最下部から離れた場合、クラスを削除
      wrapper.classList.remove('is-scrollEnd');
    }
  }
}

// テキストアニメーション用span生成
function setSpan() {
  $('.txEffect>span').each(function () {
    var text = $.trim(this.textContent),
      html = '';

    text.split('').forEach(function (v) {
      html += '<span>' + v + '</span>';
    });

    this.innerHTML = html;
  });
}

// ///////waypoint
function setWay() {
  $('.way,.way-slow,.alphaWay,.js-way').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        // scroll down
        activePoint.addClass('is-active');
        timer = setTimeout(function () {
          activePoint.addClass('is-active-after');
        }, 500);
      }
    },
    {
      offset: '70%',
    }
  );
  $('.js-item-way').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      if (direction === 'down') {
        // scroll down
        activePoint.addClass('is-active-item');
        timer = setTimeout(function () {
          activePoint.addClass('is-active-item-after');
        }, 500);
      }
    },
    {
      offset: '70%',
    }
  );
  $('.video-way').waypoint(
    function (direction) {
      var activePoint = $(this.element);
      var videoElem = activePoint.find('video');
      if (direction === 'down') {
        videoElem.get(0).play();
      }
    },
    {
      offset: '70%',
    }
  );
}

// ////////////////////////////アコーディオン
function setAcc() {
  $('.faqList .question').on('click', function () {
    $(this).parent().toggleClass('active');
    $(this).next().stop().slideToggle('fast');
  });
}

// //////////////////////////////ロード完了
function setLoaded() {
  $('#wrapper,#loading').addClass('loaded');
  loadStart();
}

function loadStart() {
  timer = setTimeout(function () {
    $('#wrapper,#loading').addClass('loadedDone');
  }, 200);
  timer = setTimeout(function () {
    $('#wrapper,#loading').addClass('loadedStart');
  }, 600);
  timer = setTimeout(function () {
    $('#wrapper').addClass('loadEnd');
    $('#mainVis').addClass('is-active');
  }, 1500);
  timer = setTimeout(function () {
    $('#wrapper').addClass('homeStart');
  }, 1200);
  if ($('#wrapper').hasClass('home')) {
    timer = setTimeout(function () {
      $('#wrapper').addClass('homeDelay');
    }, 2200);
  } else {
    timer = setTimeout(function () {
      $('#wrapper').addClass('pagesDelay');
    }, 500);
  }
  // $('body,html').animate({
  //   scrollTop: 0
  // }, 0, 'swing')
}

// ////////////ウィンドウサイズを判別
function judgeWinSize() {
  var winW = $(window).width();
  if (winW > breakNum) {
    $('#wrapper').addClass('setPc');
  } else {
    $('#wrapper').addClass('setSp');
  }

  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      winW = $(window).width();
      if (winW > breakNum) {
        $('#wrapper').addClass('setPc');
        $('#wrapper').removeClass('setSp');
      } else {
        $('#wrapper').addClass('setSp');
        $('#wrapper').removeClass('setPc');
      }
    }, 200);
  });
}

// /////////////////////////////スムーススクロール
function setScroll() {
  // var headerHeight = 0;
  // var headerHeight = $('header .col-main').height() + 50;
  if ($('#wrapper').hasClass('setPc')) {
    var headerHeight = 0;
  } else {
    var headerHeight = $('header').height();
  }
  $('a[href^="#"]').click(function (e) {
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    // var position = target.offset().top;
    if ($(this).hasClass('unqNav')) {
      closeFnc();
    }

    setTimeout(function () {
      var position = target.offset().top - headerHeight;
      $('html, body').animate(
        {
          scrollTop: position,
        },
        400,
        'swing'
      );
    }, 100);
    e.preventDefault();
  });
}

function startScroll() {
  // ページのURLを取得
  const url = $(location).attr('href'),
    // headerの高さを取得してそれに30px追加した値をheaderHeightに代入
    headerHeight = $('header').outerHeight() + 30;

  // urlに「#」が含まれていれば
  if (url.indexOf('#') != -1) {
    // urlを#で分割して配列に格納
    const anchor = url.split('#'),
      // 分割した最後の文字列（#◯◯の部分）をtargetに代入
      target = $('#' + anchor[anchor.length - 1]),
      // リンク先の位置からheaderHeightの高さを引いた値をpositionに代入
      position = Math.floor(target.offset().top) - headerHeight;
    // positionの位置に移動
    $('html, body').animate({ scrollTop: position }, 500);
  }
  setScroll();
}

// ////////////////////////////////////ランドスケープ判定
var isLandscape = function () {
  if (window.innerHeight > window.innerWidth) {
    jQuery('body').addClass('portrait');
    jQuery('body').removeClass('landscape');
  } else {
    jQuery('body').addClass('landscape');
    jQuery('body').removeClass('portrait');
  }
};

if (_ua.Mobile) {
  jQuery(window).resize(function () {
    isLandscape();
  });
  isLandscape();
}

function watchViewMode() {
  window.addEventListener('orientationchange', function () {
    // orientationchange イベントがトリガーされたときの処理をここに記述します
    location.reload(); // ページをリロードします
  });
}

// //////////////////////////////高さ揃え
function heightLineGroup() {
  // setAutoHeight('#photoDiary .articleStyle_02 .inner')
  // setAutoHeight('.vinSec ul');
  // setAutoHeight('.carouselStyle_04 .summary');
  var winW = $(window).width();
  if (winW > breakNum) {
    // setAutoHeight(".setH_01 .summary",3)
  } else {
    // setAutoHeight('.slideContent_01 .summary p', 3);
  }
  setAutoHeight('.setH_04', 2);

  startResize();
}

function setAutoHeight(target, count) {
  $(target).tile(count);
}

function startResize() {
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      heightLineGroup();
    }, 200);
  });
}
